import React from 'react';
import { SCUIS3Browser } from '../../atomic/organisms';

const S3Browser: React.FC = () => {
    return (
        <SCUIS3Browser />
    );
};

export default S3Browser;